import React from "react";
import { PaginatedTable } from "ee-react-components";
import { money } from "ee-proto-interfaces";
import { GetDisplayPrice, INTEGRATION_TO_OCPI_DISPLAY_NAME, NumberLocaleStringStyle, } from "ee-utils";
export var TransactionTable = function (_a) {
    var resourceUrl = _a.resourceUrl, buildRowLink = _a.buildRowLink, maxRows = _a.maxRows, isNoc = _a.isNoc, refreshInterval = _a.refreshInterval;
    var rowsFromResponse = function (response) { return response.transactions; };
    var rowCountFromResponse = function (response) { return response.pages; };
    var columns = [
        {
            header: "Start Time",
            accessorFn: function (row) {
                return new Date(row.sessionStart).toLocaleString();
            },
        },
        {
            header: "Duration",
            accessorFn: function (row) {
                var totalSeconds = Math.floor((new Date(row.sessionEnd).getTime() -
                    new Date(row.sessionStart).getTime()) /
                    1000);
                if (totalSeconds <= 0) {
                    return "0m 0s";
                }
                var chargeSeconds = totalSeconds % 60;
                var chargeMinutes = Math.floor(totalSeconds / 60);
                return "".concat(chargeMinutes, "m ").concat(chargeSeconds, "s");
            },
        },
        {
            header: "Energy Delivered",
            accessorFn: function (row) {
                return "".concat(Number(row.energyDeliveredKwh).toFixed(2), " kWh");
            },
        },
        {
            header: "Peak Power",
            accessorFn: function (row) {
                return "".concat(Math.round(Number(row.peakPowerKw)), " kW");
            },
        },
        {
            header: "Total",
            accessorFn: function (row) {
                return "".concat(GetDisplayPrice(row.transactionAmount, row.transactionAmountPrecision, {
                    maximumFractionDigits: 2,
                    useLocaleString: true,
                    localeStringStyle: NumberLocaleStringStyle.Currency,
                }));
            },
        },
        {
            header: "Support Free Session",
            accessorFn: function (row) {
                return row.freeReason === money.FreeReason.SUPPORT_AGENT_FREE_SESSION
                    ? "Yes"
                    : "";
            },
        },
        {
            header: "Charger ID",
            accessorFn: function (row) {
                return row.chargerFriendlyId;
            },
        },
        {
            header: "Third Party Source",
            accessorFn: function (row) {
                return INTEGRATION_TO_OCPI_DISPLAY_NAME.get(row.emspName);
            },
        },
    ];
    if (isNoc) {
        columns.push({
            header: "Port ID",
            accessorFn: function (row) {
                return "".concat(row.portId);
            },
        });
    }
    return (React.createElement(PaginatedTable, { baseUrl: resourceUrl, itemsPerPage: maxRows !== null && maxRows !== void 0 ? maxRows : 10, rowsFromResponse: rowsFromResponse, rowCountFromResponse: rowCountFromResponse, columnDefinitions: columns, buildRowLink: buildRowLink, refreshInterval: refreshInterval }));
};
